import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Paper from '@material-ui/core/Paper/index';
import IconButton from "@material-ui/core/IconButton/index";
import Zoom from "@material-ui/core/Zoom/index";
import Tooltip from "@material-ui/core/Tooltip/index";
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {GoogleDriveService} from "../../../../services/GoogleDriveService/GoogleDriveService";
import {CONFIG} from "../../../../settings/Config/Config";
import {CloudDownload, DeleteOutlined, Folder, InsertDriveFile, Share} from "@material-ui/icons";
import ModalRenombrar from "./ModalRenombrar";
import moment from "moment";

class ListaTabla extends Component {
	
	Usr = {};
	
	constructor(props) {
		super(props);
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
	}
	
	esCarpeta = (item) => {
		return item.tipo === 'folder' || item.isArchivo === false;
	};
	
	formatSize = (bytes) => {
		if (!(bytes > 0)) {
			return '-';
		}
		let k = 1024;
		let sizes = ['B', 'KB', 'MB', 'GB'];
		let i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
	};
	
	nuevaFecha = (d) => {
		let fecha = '';
		if (d) {
			let f = String(d).split('T');
			fecha = moment(f[0]).format("DD/MM/YYYY");
		}
		return fecha;
	};
	
	eliminar = (item) => {
		let nombre = item.nombre || item.name;
		let msg = `¿Deseas eliminar ${this.esCarpeta(item) ? 'la carpeta' : 'el archivo'} ${nombre}?`;
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			if (r.button === 'Eliminar') {
				GoogleDriveService.Eliminar(item).then((response) => {
					this.props.showSnackBars('success', response.mensaje);
					this.props.RefreshList();
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			}
		});
	};
	
	abrirItem = (item) => {
		if (this.esCarpeta(item)) {
			this.props.gerContentFile(item.path_display, item.name || item.nombre, item.item_id);
		}
	};
	
	render() {
		
		const {lista} = this.props;
		
		return (
			<Paper style={{overflowX: "auto"}}>
				<Table className={'desing-acresco'}>
					<TableHead>
						<TableRow>
							<TableCell component="th" align={'left'} className={'padding-20-L padding-20-R'}>Nombre</TableCell>
							<TableCell component="th" align={'left'}>Tipo</TableCell>
							<TableCell component="th" align={'left'}>Tamaño</TableCell>
							<TableCell component="th" align={'left'}>Fecha de modificación</TableCell>
							<TableCell component="th" align={'center'} className={'w-180-px'}>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{lista.map((item, key) => (
							<TableRow key={key}>
								<TableCell align={'left'} className={'padding-20-L padding-20-R'}>
									<div className={'vertical-inline ' + (this.esCarpeta(item) ? 'cursor-pointer' : '')} onClick={() => this.abrirItem(item)}>
										<div className={'v-center padding-15-R'}>
											{this.esCarpeta(item) ? (
												<Folder style={{fontSize: '32px', color: 'rgb(142, 30, 50)'}}/>
											) : (
												<InsertDriveFile style={{fontSize: '32px', color: '#3f50b6'}}/>
											)}
										</div>
										<div className={'v-center'}>
											{item.name || item.nombre}
										</div>
									</div>
								</TableCell>
								<TableCell align={'left'}>{this.esCarpeta(item) ? 'Carpeta' : (item.extension || 'Archivo')}</TableCell>
								<TableCell align={'left'}>{this.esCarpeta(item) ? '-' : this.formatSize(item.size)}</TableCell>
								<TableCell align={'left'}>{this.nuevaFecha(item.lastModifiedDateTime)}</TableCell>
								<TableCell align={'center'} className={'padding-5-L padding-5-R'}>
									<div className={'w-auto vertical-inline'}>
										{!this.esCarpeta(item) ? (
											<div className={'v-center'}>
												<Tooltip TransitionComponent={Zoom} placement={"top"} title="Descargar">
													<IconButton aria-label="Descargar" onClick={() => this.props.descargarArchivo(item)}>
														<CloudDownload style={{color: 'rgb(142, 30, 50)'}}/>
													</IconButton>
												</Tooltip>
											</div>
										) : null}
										
										<div className={'v-center'}>
											<Tooltip TransitionComponent={Zoom} placement={"top"} title="Compartir">
												<IconButton aria-label="Compartir" onClick={() => this.props.compartirArchivo(item)}>
													<Share/>
												</IconButton>
											</Tooltip>
										</div>
										
										<div className={'v-center'}>
											<ModalRenombrar
												tipo={'edit'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
										
										<div className={'v-center'}>
											<Tooltip TransitionComponent={Zoom} placement={"top"} title="Eliminar">
												<IconButton aria-label="Eliminar" onClick={() => this.eliminar(item)}>
													<DeleteOutlined/>
												</IconButton>
											</Tooltip>
										</div>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Paper>
		)
	}
}

ListaTabla.propTypes = {
	gerContentFile: PropTypes.func.isRequired,
	descargarArchivo: PropTypes.func.isRequired,
	compartirArchivo: PropTypes.func.isRequired,
	lista: PropTypes.array.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ListaTabla;
